;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Img from 'components/ui/Img';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import { blockRootProps } from 'utils';

import Graph from './Graph';
import Spinner from './Spinner';

import styles from './BlockCommitmentChart.module.scss';

const BlockCommitmentChart = ({
    __typename,
    anchorId,
    headline,
    bodyCopy,
    image,
    imageLarge,
    chartHeadline,
    standardsList,
    chartCopy,
    theme,
    flushTop,
    flushBottom,
}) => {
    theme ??= 'Progress';

    if (theme === 'Standards') {
        return (
            <div
                {...blockRootProps(anchorId, __typename)}
                className={cx(styles.chartRow, {
                    [styles.flushTop]: flushTop,
                    [styles.flushBottom]: flushBottom,
                })}
            >
                <div className={styles.innerChart}>
                    <div className={styles.lockup}>
                        {headline && (
                            <Text
                                className={cx(
                                    styles.headline,
                                    styles.standardsHeadline
                                )}
                                baseTheme={
                                    theme === 'numbers'
                                        ? 'displayMedium'
                                        : 'headingLarge'
                                }
                                themes={
                                    theme === 'numbers'
                                        ? {
                                              large: 'displayLarge',
                                          }
                                        : {
                                              large: 'headingLarge',
                                          }
                                }
                            >
                                {headline}
                            </Text>
                        )}
                        {bodyCopy && (
                            <div className={styles.copyWrapper}>
                                <Text
                                    className={styles.bodyCopy}
                                    baseTheme={
                                        theme === 'numbers'
                                            ? 'bodyMedium'
                                            : 'bodySmall'
                                    }
                                    themes={
                                        theme === 'numbers'
                                            ? { large: 'bodyLarge' }
                                            : { large: 'bodyMedium' }
                                    }
                                >
                                    {bodyCopy}
                                </Text>
                            </div>
                        )}
                    </div>

                    <div className={styles.chartInner}>
                        <div className={styles.chart}>
                            {chartHeadline && (
                                <Text
                                    className={styles.chartHeadline}
                                    baseTheme={'displayXSmall'}
                                    themes={{
                                        large: 'displayXSmall',
                                    }}
                                >
                                    {chartHeadline}
                                </Text>
                            )}
                            {chartCopy && (
                                <Text
                                    className={styles.chartCopy}
                                    baseTheme={'bodySmall'}
                                    themes={{
                                        large: 'bodySmall',
                                    }}
                                >
                                    {chartCopy}
                                </Text>
                            )}
                            {standardsList && (
                                <div className={styles.standardsList}>
                                    {standardsList.map((standard, id) => {
                                        return (
                                            <div
                                                className={
                                                    styles.standardWrapper
                                                }
                                                key={id}
                                            >
                                                <div
                                                    className={
                                                        styles.standardIconWrapper
                                                    }
                                                >
                                                    <SvgIcon
                                                        className={
                                                            styles.standardIcon
                                                        }
                                                        type={'roundCheck'}
                                                    />
                                                </div>
                                                <Text
                                                    className={styles.standard}
                                                    baseTheme={'headingXSmall'}
                                                    themes={{
                                                        large: 'headingSmall',
                                                    }}
                                                >
                                                    {standard}
                                                </Text>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (theme === 'Graph1') {
        return (
            <div {...blockRootProps(anchorId, __typename)}>
                <Graph headline={headline} bodyCopy={bodyCopy} theme={theme} />
            </div>
        );
    }

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.commitmentChart, {
                [styles.draggableChart]: theme === 'Draggable',
            })}
        >
            <div className={styles.contentWrapper}>
                <div className={styles.innerWrapper}>
                    <div className={styles.lockup}>
                        {headline && (
                            <Text
                                className={styles.headline}
                                baseTheme={'displaySmall'}
                                themes={{
                                    large: 'displayLarge',
                                }}
                            >
                                {headline}
                            </Text>
                        )}
                        {bodyCopy && (
                            <Text
                                className={styles.copy}
                                baseTheme={'bodySmall'}
                                themes={{
                                    large: 'bodyMedium',
                                }}
                            >
                                {bodyCopy}
                            </Text>
                        )}
                    </div>
                </div>
                {theme === 'Draggable' ? (
                    <Spinner className={styles.imgBlock}>
                        <Img
                            className={styles.img}
                            src={image?.url}
                            width={image?.width}
                            height={image?.height}
                            alt={image?.description || ''}
                            fallbackImageWidth={768}
                            customSources={[
                                {
                                    breakpoint: 768,
                                    src: imageLarge?.url,
                                    imageWidth: 1420,
                                },
                                {
                                    src: image?.url,
                                    imageWidth: 1024,
                                },
                            ]}
                        />
                    </Spinner>
                ) : (
                    <div className={styles.imgBlock}>
                        <Img
                            className={styles.img}
                            src={image?.url}
                            width={image?.width}
                            height={image?.height}
                            alt={image?.description || ''}
                            fallbackImageWidth={768}
                            customSources={[
                                {
                                    breakpoint: 768,
                                    src: imageLarge?.url,
                                    imageWidth: 1420,
                                },
                                {
                                    src: image?.url,
                                    imageWidth: 1024,
                                },
                            ]}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

BlockCommitmentChart.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    bodyCopy: PropTypes.string,
    chartCopy: PropTypes.string,
    chartHeadline: PropTypes.string,
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    headline: PropTypes.string,
    image: PropTypes.object,
    imageLarge: PropTypes.object,
    standardsList: PropTypes.array,
    theme: PropTypes.oneOf([
        'Progress',
        'Draggable',
        'Standards',
        'Graph1',
        'Graph2',
    ]),
};

export default BlockCommitmentChart;
